// Display formatting for storage plans. The billing cadence comes from the
// Stripe price (`interval`) rather than being inferred from `kind`, so the UI
// always says what Stripe will actually charge.

export const sizeLabel = (storageGb: number) =>
  storageGb >= 1024 ? `${storageGb / 1024} TB` : `${storageGb} GB`;

export const formatPrice = (price: number, currency = 'usd') =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    // Plans are whole-dollar; drop the ".00" but keep cents if a price ever
    // has them.
    minimumFractionDigits: Number.isInteger(price) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(price);

const INTERVAL_SUFFIX: Record<StoragePlanInterval, string> = {
  day: 'per day',
  week: 'per week',
  month: 'per month',
  year: 'per year',
};

// Sits after the price in the plan row: "$760 once", "$145 per year".
export const periodLabel = (plan: StoragePlanType) =>
  plan.interval ? INTERVAL_SUFFIX[plan.interval] : 'once';

const INTERVAL_SHORT: Record<StoragePlanInterval, string> = {
  day: 'daily',
  week: 'weekly',
  month: 'monthly',
  year: 'annual',
};

// Sits beside the total in the footer: "$760 one-time", "$145 annual".
export const billingLabel = (plan: StoragePlanType) =>
  plan.interval ? INTERVAL_SHORT[plan.interval] : 'one-time';

const INTERVAL_ADVERB: Record<StoragePlanInterval, string> = {
  day: 'daily',
  week: 'weekly',
  month: 'monthly',
  year: 'annually',
};

// "Renews annually" on the review step. Only meaningful for recurring plans.
export const renewalLabel = (plan: StoragePlanType) =>
  plan.interval ? INTERVAL_ADVERB[plan.interval] : '';
